export default __webpack_public_path__ + "static/media/partner-02.12a40c09.png";